import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BookIcon from "@mui/icons-material/Book";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setTheme } from "../../redux/actions/styles";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import InterestsIcon from "@mui/icons-material/Interests";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import LocalDiningRoundedIcon from "@mui/icons-material/LocalDiningRounded";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";

const BottomTabs = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { outlet, table, section } = useParams();

  const { darkTheme } = useSelector((state) => state.styles);

  const { cart } = useSelector((state) => state.checkout);

  const [bottomTabsVisible, setbottomTabsVisible] = useState(true);
  const { activeOutlet } = useSelector((state) => state.config);
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.removeItem("theme");
    }
  }, [darkTheme]);

  return (
    <div className={`bottom-tabs ${bottomTabsVisible ? "visible" : ""}`}>
      {activeOutlet ? (
        <Link
          to={table ? `/${outlet}/${table}` : `/${outlet}`}
          className={`tab ${
            pathname === `/${outlet}` ||
            pathname === `/${outlet}/${table}` ||
            pathname === `/${outlet}/section/${section}` ||
            pathname === `/${outlet}/${table}/section/${section}`
              ? "tab-active"
              : ""
          }`}
        >
          <div className="icon">
            <DashboardIcon />
          </div>
          <p>Menu</p>
        </Link>
      ) : (
        <Link to="/" className={`tab ${pathname === "/outlets" ? "tab-active" : ""}`}>
          <div className="icon">
            <DashboardIcon />
          </div>
          <p>Outlets</p>
        </Link>
      )}
      {/* <div className="border" /> */}
      {/* <Link to="/reservations" className={`tab ${pathname.includes("/reservations") ? "tab-active" : ""}`}>
        <div className="icon">
          <BookIcon />
        </div>
        <p>Reservations</p>
      </Link>
      <div className="border" /> */}
      <div className="border" />

      <Link
        to={activeOutlet ? (table ? `/cart/${outlet}/${table}` : `/cart/${outlet}`) : "/cart"}
        className={`tab ${pathname.includes("/cart") ? "tab-active" : ""}`}
      >
        <div className="icon">
          <ShoppingCartIcon />
          {cart.length > 0 && (
            <div className="badge">
              <span>{cart.length}</span>
            </div>
          )}
        </div>
        <p>Cart</p>
      </Link>
      {table && (
        <Link
          to={activeOutlet ? (table ? `/your-orders/${outlet}/${table}` : `/your-orders/${outlet}`) : "/your-orders"}
          className={`tab ${pathname.includes("/your-orders") ? "tab-active" : ""}`}
        >
          <div className="icon">
            <RestaurantRoundedIcon />
            {/* {cart.length > 0 && (
            <div className="badge">
              <span>{cart.length}</span>
            </div>
          )} */}
          </div>
          <p>Orders</p>
        </Link>
      )}
      <div className={`tab`} onClick={() => dispatch(setTheme(!darkTheme))}>
        <div className="icon">{darkTheme ? <LightModeIcon /> : <NightsStayIcon />}</div>
        <p>{darkTheme ? "Light" : "Dark"}</p>
      </div>
      {isAuthenticated ? (
        <Link
          to={activeOutlet ? (table ? `/manage/${outlet}/${table}` : `/manage/${outlet}`) : "/manage"}
          className={`tab ${pathname === "/manage" || pathname === `/manage/${outlet}` ? "tab-active" : ""}`}
        >
          <div className="icon">
            <AppRegistrationIcon style={{ fontSize: "2rem" }} />
          </div>
          <p>Manage</p>
        </Link>
      ) : (
        <Link
          to={activeOutlet ? (table ? `/more/${outlet}/${table}` : `/more/${outlet}`) : "/more"}
          className={`tab ${pathname.includes("/more") ? "tab-active" : ""}`}
        >
          <div className="icon">
            <InterestsIcon />
          </div>
          <p>More</p>
        </Link>
      )}
    </div>
  );
};

export default BottomTabs;
